import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/signature/list',
    name: ROUTES.SIGNATURE_REQUESTS,
    component: () => import('../views/signature/SignatureList.vue'),
  },
  {
    path: '/:accountId/signature/prepare-for-signing',
    name: ROUTES.PREPARE_FOR_SIGNING,
    component: () => import('../views/signature/PrepareForSigningPage.vue'),
  },
  {
    path: '/:accountId/signature/:signatureRequestId',
    name: ROUTES.USER_SIGNATURE,
    component: () => import('../views/signature/SignatureSigning.vue'),
  },
  {
    path: '/signature/:token',
    name: ROUTES.SIGNATURE,
    component: () => import('../views/signature/SignatureSigning.vue'),
  },
]
